import { LOADING_STATES } from "../../../features/loading";

import { CampaignBriefsState } from "./campaign-briefs.interface";

export function createCampaignBriefsState(): CampaignBriefsState {
  return {
    count: 0,
    duplicateBriefId: null,
    errors: null,
    filters: { briefOwners: [] },
    loading: { ...LOADING_STATES.default },
    next: null,
    previous: null,
  };
}
